import React, { Component } from 'react';

class PageTitle extends Component {
  render() {
    return (
      <div className="page-header animate-fade-in-up">
        {this.props.eyebrow && (
          <div>
            <span className="section-eyebrow">{this.props.eyebrow}</span>
          </div>
        )}
        <h1 className="page-title">{this.props.pageTitle}</h1>
        {this.props.subtitle && <p className="page-subtitle">{this.props.subtitle}</p>}
      </div>
    );
  }
}

export default PageTitle;
